import { MenuitemsType } from '@/layouts/full/vertical/sidebar/MenuItems';
import { MenuPermission } from '@/types';

/**
 * Фільтрує елементи меню на основі прав доступу користувача
 */
export const filterMenuByPermissions = (
  menuItems: MenuitemsType[],
  hasPermission: (permission?: MenuPermission) => boolean
): MenuitemsType[] => {
  return menuItems
    .map(item => {
      // Перевіряємо доступ до поточного елементу
      if (!hasPermission(item.permission)) {
        return null;
      }

      // Якщо є дочірні елементи, фільтруємо їх також
      if (item.children) {
        const filteredChildren = filterMenuByPermissions(item.children, hasPermission);
        
        // Якщо після фільтрації не залишилося дочірніх елементів,
        // але батьківський елемент має href, залишаємо його
        if (filteredChildren.length === 0 && !item.href) {
          return null;
        }

        return {
          ...item,
          children: filteredChildren,
        };
      }

      return item;
    })
    .filter((item): item is MenuitemsType => item !== null);
};
